export default __webpack_public_path__ + "static/media/BV_110.cd8e00f6.jpg";